import React, { useEffect, useState } from 'react'
import { useSinglePresaleInfoMutation } from './store/ReduxApis';
import { useHistory } from 'react-router-dom';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import toast, { Toaster } from 'react-hot-toast';
import { useParams } from 'react-router-dom'

function ViewPresaleRoundInfo() {
    const { id } = useParams();

    const [presaleData, setPresaleData] = useState({})
    const [createPost, responseInfo] = useSinglePresaleInfoMutation();
 
 const getOneData = async () => {
    const updateUserDetails = await createPost({ "_id": id})
    .then(res => {
        setPresaleData(res?.data?.data, "res")
    })
    console.log(updateUserDetails, "details")
  }

  useEffect(() => {
    getOneData();
  }, [])

  console.log("presaleDataVal:", presaleData)
  return (
      <div>
          <Toaster />
          
          <div class="content-wrapper">

  <section class="content-header">
      <div class="container-fluid">
          <div class="row mb-2">
              <div class="col-sm-6 text">
                  <h1>View Presale</h1>
              </div>
              <div class="col-sm-6">
                  <ol class="breadcrumb float-sm-right">
                      <li class="breadcrumb-item"><a href="#">Home</a></li>
                      <li class="breadcrumb-item active">View Presale</li>
                  </ol>
              </div>
          </div>
      </div>
  </section>
  

  <section class="content">
      <div class="container-fluid">
          <div class="row">
              <div class="col-md-6 offset-md-2">
                 
                  <div class="card card-outline card-primary">

                  <div class="card-body">
                  <div class="form-group">

                  <div className="form-group secondItem">
                        <label className="col-sm-4 control-label" for="inputEmail3">Presale Title</label>
                        <div className="col-sm-6">
                        <p className='text-black'>{presaleData?.presaleTitle}</p>
                        </div>
                    </div>

                    {/* <div className="form-group secondItem">
                        <label className="col-sm-4 control-label" for="inputEmail3">Price ( USD )</label>
                        <div className="col-sm-6">
                        <p className='text-black'>{presaleData?.price}</p>
                        </div>
                    </div> */}

                    <div className="form-group secondItem">
                        <label className="col-sm-4 control-label" for="inputEmail3">Supply</label>
                        <div className="col-sm-6">
                        <p className='text-black'>{presaleData?.supply}</p>
                        </div>
                    </div>

                    {/* <div className="form-group secondItem">
                        <label className="col-sm-4 control-label" for="inputEmail3">Price (BNB)</label>
                        <div className="col-sm-6">
                        <p className='text-black'>{presaleData?.price}</p>
                        </div>
                    </div> */}

                    <div className="form-group secondItem">
                        <label className="col-sm-4 control-label" for="inputEmail3">Price (USDT)</label>
                        <div className="col-sm-6">
                        <p className='text-black'>{presaleData?.priceinusd}</p>
                        </div>
                    </div>

                    <div className="form-group secondItem">
                        <label className="col-sm-4 control-label" for="inputEmail3">Sale Percentage</label>
                        <div className="col-sm-6">
                        <p className='text-black'>{presaleData?.salepercentage}</p>
                        </div>
                    </div>


                    {/* <div className="form-group secondItem">
                        <label className="col-sm-4 control-label" for="inputEmail3">Min Amount</label>
                        <div className="col-sm-6">
                        <p className='text-black'>{presaleData?.minAmount}</p>
                        </div>
                    </div>


                    <div className="form-group secondItem">
                        <label className="col-sm-4 control-label" for="inputEmail3">Max Amount</label>
                        <div className="col-sm-6">
                        <p className='text-black'>{presaleData?.maxAmount}</p>
                        </div>
                    </div> */}


                    <div className="form-group secondItem">
                        <label className="col-sm-4 control-label" for="inputEmail3">Status</label>
                        <div className="col-sm-6">
                        <p className='text-black'>{presaleData?.status}</p>
                        </div>
                    </div>

                    <div className="form-group secondItem">
                        <label className="col-sm-4 control-label" for="inputEmail3">Start Date</label>
                        <div className="col-sm-6">
                        <p className='text-black'>{presaleData?.startDate}</p>
                        </div>
                    </div>

                    <div className="form-group secondItem">
                        <label className="col-sm-4 control-label" for="inputEmail3">End Date</label>
                        <div className="col-sm-6">
                        <p className='text-black'>{presaleData?.endDate}</p>
                        </div>
                    </div>

                    </div>
                    </div>

                  {/* <form onSubmit={(e) => addUser(e)}>
                  <div class="card-body">
                  <div class="form-group">
  <input type = "text" class = "txtPost" placeholder = "First Name" name='firstName' onChange={(e) => setFirstName(e.target.value)} required />
  <input type = "text" class = "txtPost" placeholder = "Last Name" name='lastName' onChange={(e) => setLastName(e.target.value)} required />
  <input type = "text" class = "txtPost" placeholder = "Email" name='email' onChange={(e) => setEmail(e.target.value)} required />
  <input type = "text" class = "txtPost" placeholder = "Password" name='password' onChange={(e) => setPassword(e.target.value)} required />
  <input type = "text" class = "txtPost" placeholder = "Password Confirmation" name='confirmPassword' onChange={(e) => setConfirmPassword(e.target.value)} required />
  
  <button type='submit' class = "btnPost">Add Admin</button>
  </div>
  </div>
</form>
                       */}

                      {/* <form>
                          <div class="card-body">

                              <div class="form-group">
                                  <label>First Name</label>
                                  <input type="text" onChange={(e) => setFirstName(e.target.value)} formControlName="firstName" class="form-control"
                                       />

                                  <div>
                                      
                                    
                                  </div>
                              </div>

                              <div class="form-group">
                                  <label>Last Name</label>
                                  <input type="text" onChange={(e) => setLastName(e.target.value)} formControlName="lastName" class="form-control" required
                                     />

                                  <div>
                                      <div>Last Name is required</div>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <label>Email</label>
                                  <input type="text" onChange={(e) => setEmail(e.target.value)} formControlName="email" class="form-control" required />

                                  <div>
                                      <div>Email is required</div>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <label>Password</label>
                                  <input type="password" onChange={(e) => setPassword(e.target.value)} formControlName="password" class="form-control" required
                                      />

                                  <div >
                                      <div>Password is required</div>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <label>Confirm Password</label>
                                  <input type="password" onChange={(e) => setConfirmPassword(e.target.value)} formControlName="confirmPassword" class="form-control" required
                                       />

                                  <div>
                                      <div>Confirm Password is required</div>
                                  </div>
                              </div>


                          </div>
                          
                          <div class="card-footer">
                              <button type="submit" onClick={(e) => addUser(e)} class="btn btn-primary">Submit</button>
                          </div>
                      </form> */}
                  </div>

              </div>
              



          </div>

      </div>
      
  </section>
  
  


          </div>
          
    </div>
  )
}

export default ViewPresaleRoundInfo